import React, { useState, useEffect, useContext } from 'react';

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

import i18n from '../i18n'
import LocaleContext from '../LocaleContext'

import { LinkContainer } from 'react-router-bootstrap';

import { Role } from '../_helpers';
import { accountService } from '../_services';
import SideNavLogo from "../assets/images/tib-side-logo-wh.png";
import { useTranslation } from 'react-i18next';
import { NavDropdown } from 'react-bootstrap';


function Navigation() {
  const hideLanguages = !(accountService.configValue["useTranslations"] === 'true');
  const { t } = useTranslation();
  const [user, setUser] = useState({});
  const [todayResCount, setTodayResCount] = useState(0);
  const [futureResCount, setFutureResCount] = useState(0);
  const { locale } = useContext(LocaleContext);

  const lang_labels = {
    "en": "English (US)",
    "fr-CA": "French (CAN)"
  }

  function changeLocale(l) {
    if (locale !== l) {
      i18n.changeLanguage(l);
      localStorage.setItem('Language', l);
    }

  }

  useEffect(() => {
    console.log("NAV MOUNTED!")
    const subscription = accountService.user.subscribe(x => setUser(x));
    const subscription2 = accountService.todayReservationCount.subscribe(x => setTodayResCount(x));
    const subscription3 = accountService.futureReservationCount.subscribe(x => setFutureResCount(x));

    return () => {
      console.log("NAV UNMOUNTED!")
      subscription.unsubscribe();
      subscription2.unsubscribe();
      subscription3.unsubscribe();
    }
  }, []);

  if (!user) {
      return (
          <div>
              <div className="lang-nav">
                  <div className="lang-dropdown-menu">
                      <NavDropdown className="lang-select-box" hidden={hideLanguages} id="nav-dropdown-dark" title={lang_labels[i18n.language]}>
                          <div>
                              <NavDropdown.Item className="lang-dropdown" href="#" onClick={() => changeLocale('en')}>English (US)</NavDropdown.Item>
                              <NavDropdown.Item className="lang-dropdown" href="#" onClick={() => changeLocale('fr-CA')}>French (CAN)</NavDropdown.Item>
                          </div>
                      </NavDropdown>
                  </div>
              </div>

              <div className="login-nav">
                  <div className="row logo-home">

                      <span className="navbar-brand-home">
                          <LinkContainer to="/">
                              <Nav.Link><img src={SideNavLogo} alt="Tiburon Lockers Logo" className="logo" /></Nav.Link>

                          </LinkContainer>
                      </span>

                  </div>
              </div>
          </div>
    )
  } else {
      return (
          <div className="lang-nav">
            <div className="lang-dropdown-menu">
                <NavDropdown className="lang-select-box" hidden={hideLanguages} id="nav-dropdown-dark" title={lang_labels[i18n.language]}>
                    <div>
                        <NavDropdown.Item className="lang-dropdown" href="#" onClick={() => changeLocale('en')}>English (US)</NavDropdown.Item>
                        <NavDropdown.Item className="lang-dropdown" href="#" onClick={() => changeLocale('fr-CA')}>French (CAN)</NavDropdown.Item>
                        </div>
                </NavDropdown>
                </div>
        <Navbar collapseOnSelect expand="sm"  >
          <Navbar.Brand>
            <LinkContainer to="/">
              <Nav.Link><img src={SideNavLogo} alt="Tiburon Lockers Logo" className="logo" /></Nav.Link>

            </LinkContainer>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="nbarnav" />
          <Navbar.Collapse id="nbarnav">
            <Nav >

                {user.role === Role.Admin &&
                    <LinkContainer to="/admin">
                      <Nav.Link className="nav-item nav-link">Admin</Nav.Link>
                    </LinkContainer>
                }

                {(user.role === Role.LockerAdmin || user.role === Role.Admin) &&
                    <LinkContainer to="/lockers-admin">
                        <Nav.Link className="nav-item nav-link">Lockers</Nav.Link>
                    </LinkContainer>
                }

              <LinkContainer to="/">
                <Nav.Link className="nav-item nav-link">{t('Home')}</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/new-reservation">
                <Nav.Link className="nav-item nav-link">{t('Rent')}</Nav.Link>
              </LinkContainer>
              {(todayResCount > 0) &&
                <LinkContainer to="/reservations/active">
                  <Nav.Link className="nav-item nav-link">{t('Lockers')}</Nav.Link>
                </LinkContainer>
              }
              {(futureResCount > 0) &&
                <LinkContainer to="/reservations/all">
                  <Nav.Link className="nav-item nav-link">{t('Reservations')}</Nav.Link>
                </LinkContainer>
              }
              <LinkContainer to="/profile/">
                <Nav.Link className="nav-item nav-link">{t('Account')}</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/contact">
                <Nav.Link className="nav-item nav-link">{t('Help')}</Nav.Link>
              </LinkContainer>
              <Nav.Link onClick={accountService.logout} className="nav-item nav-link">
                {t('Logout')}
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>

    );
  }

}

export { Navigation };